import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Col, Row, Label, FormGroup, Input } from "reactstrap";
import { YearsArray } from "../../../store/Utility/Data";
import AutoCompleteInput from "../../../Componet/Autocomplete/AutoCompleteInput";
import axios from "../../../api/axios";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { v4 as uuidv4 } from 'uuid';
import LocationAutocomplete from '../../../Componet/Autocomplete/LocationAutocomplete';
import Options from "../../../Componet/Option/Options";
import { States } from "../../../store/Utility/Data";
import PhoneMaskInput from "../../../Componet/PhoneMaskInput";
import SpinnerButton from "../../../Componet/Button/SpinnerButton";
import { isNullOrEmpty, isValidEmail, isValidPhoneNumber } from "../../../store/Utility/Helper";
import Modal from 'react-bootstrap/Modal';


import truck from '../../../assets/images/icon/truck.png';
import motorbike from '../../../assets/images/icon/motorbike.png';
import van from '../../../assets/images/icon/van.png';
import car from '../../../assets/images/icon/car.png';


const InitialData = {
    id: uuidv4(),
    vehicleType: "",
    isCarfaxReportRequested: false,
    category: "",
    make: "",
    model: "",
    year: "",
    licensePlate: "",
    VIN: "",
    sellerContactName: "",
    sellerAddress: "",
    sellerCity: "",
    sellerState: "",
    sellerZipCode: "",
    sellerPhone: "",
    requesterFirstName: "",
    requesterLastName: "",
    requesterEmail: "",
    requesterAddress: "",
    requesterCity: "",
    requesterState: "",
    requesterZipCode: "",
    requesterPhone: "",
    requesterNote: "",
    isTermAndConditionAccepted: false,
    quotationStep: 1,
    sellerLatitude: null,
    sellerLongitude: null
}

const OrderForm = ({ onSubmit, onSaveAsDraft, orderId }) => {
    const [data, setData] = useState(InitialData);
    const [makes, setMake] = useState();
    const [prices, setPrices] = useState();
    const [disableMake, setDisableMake] = useState(true);
    const [disableModel, setDisableModel] = useState(true);
    const [vehicleType, setVehicleType] = useState("");
    const [makeInput, setMakeInput] = useState();
    const [modelInput, setModelInput] = useState();
    const [models, setModel] = useState();
    const [isTermsAndConditionChecked, setIsTermsAndConditionChecked] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showPaymentForm, setShowPaymentForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [draftLoading, setDraftLoading] = useState(false);
    const [validationError, setValidationError] = useState({});
    const axiosPrivate = useAxiosPrivate();
    const location = useLocation();


    function updateFields(fields) {
        setData(prev => {
            return { ...prev, ...fields }
        })
    }

    const handleChange = (e) => {
        setVehicleType(e.target.value);
    };


    const onMakeClick = (clickedItem) => {
        setMakeInput(clickedItem.name);
        setModelInput("");
        getModelByMakeId(clickedItem.id);
        updateFields({ makeId: clickedItem.id, make: clickedItem.name });
        updateFields({ modelId: "", model: "" });
    }

    const onMakeChange = (event) => {
        setMakeInput(event.target.value);
    }

    const onModelChange = (event) => {
        setModelInput(event.target.value);
    }

    const onModelClick = (clickedItem) => {
        updateFields({ modelId: clickedItem.id, model: clickedItem.name });
        setModelInput(clickedItem.name);

    }

    const handleMakeChange = (event) => {
        getModelByMakeId(event.target.value);
        updateFields({ makeId: event.target.value, make: event.target[event.target.selectedIndex].text });
    }

    useEffect(() => {
        const getMakes = async () => {
            const response = await axios.get(`v1/make`).then(res => {
                setMake(res.data.data);
                setDisableMake(false);
            });
        }
        updateFields({ id: uuidv4() });
        if (orderId) {
            getOrder(orderId);
        }
        getPrices();
        getMakes();
        if (data.makeId != null && data.makeId != "") {
            getModelByMakeId(data.makeId);
        }
    }, []);

    const getOrder = async (id) => {
        const response = await axiosPrivate.get(`v1/tenant/order/${id}`).then(res => {
            setData(res.data.data);
            setMakeInput(res.data.data.make);
            setModelInput(res.data.data.model);
        });

    }

    const getModelByMakeId = async (makeId) => {
        const response = await axios.get(`v1/model/${makeId}`).then(res => {
            setModel(res.data.data);
            setDisableModel(false);
        });
    }
    const getPrices = async () => {
        const response = await axiosPrivate.get(`v1/tenant/prices`).then(res => {
            setPrices(res.data.data);
        });
    }

    const onSellerPlaceChanged = (place) => {
        if (!place) return;
        const addressComponents = place.address_components;

        var result = {
            sellerCity: data.sellerCity,
            sellerState: data.sellerState,
            sellerZipCode: data.sellerZipCode,
            sellerAddress: data.sellerAddress
        };

        const state = addressComponents.find(component => component.types.includes('administrative_area_level_1'));
        if (state != null) {
            result.sellerState = state.short_name;
        }
        const city = addressComponents.find(component => component.types.includes('locality'));
        if (city != null) {
            result.sellerCity = city.long_name;
        } else {
            const sublocalityCity = addressComponents.find(component => component.types.includes('sublocality'));
            if (sublocalityCity != null) {
                result.sellerCity = sublocalityCity.long_name;
            } else {
                const neighborhoodCity = addressComponents.find(component => component.types.includes('neighborhood'));
                if (neighborhoodCity != null) {
                    result.sellerCity = neighborhoodCity.long_name;
                }
            }
        }


        const postalCode = addressComponents.find(component => component.types.includes('postal_code'));

        if (place.formatted_address) {
            result.sellerAddress = place.formatted_address;
        }

        if (postalCode) {
            result.sellerZipCode = postalCode.short_name;
        }

        if (place.geometry.location) {
            result.sellerLatitude = place.geometry.location.lat();
            result.sellerLongitude = place.geometry.location.lng();
        }

        if (Object.keys(result).length > 0) {
            updateFields({ ...result });
        }
    }

    const checkHandler = (event) => {
        // setIsTermsAndConditionChecked(!isTermsAndConditionChecked);
        // updateFields({ isTermAndConditionAccepted: !isTermAndConditionAccepted });
        setData(prev => ({
            ...prev,
            isTermAndConditionAccepted: !prev.isTermAndConditionAccepted
        }))
    }

    const openTermsAndConditionModal = () => {
        setShowModal(true);
    }

    const handleClose = () => {
        setShowModal(false);
    }

    const validateForm = (inputValues) => {
        let errors = {};

        console.log(inputValues.vehicleType);
        if (isNullOrEmpty(inputValues.vehicleType)) errors.vehicleType = "Select vehicle type";

        if (isNullOrEmpty(inputValues.makeId)) errors.makeId = "Select make";

        if (isNullOrEmpty(inputValues.modelId)) errors.modelId = "Select model";

        if (isNullOrEmpty(inputValues.year)) errors.year = "Select year";
        if (isNullOrEmpty(inputValues.sellerContactName)) errors.sellerContactName = "Enter contact name";
        if (isNullOrEmpty(inputValues.sellerAddress)) errors.sellerAddress = "Select seller address";
        if (isNullOrEmpty(inputValues.sellerCity)) errors.sellerCity = "Enter seller city";
        if (isNullOrEmpty(inputValues.sellerState)) errors.sellerState = "Select state";
        if (isNullOrEmpty(inputValues.sellerZipCode)) errors.sellerZipCode = "Enter seller zip code";
        if (!isValidPhoneNumber(inputValues.sellerPhone)) errors.sellerPhone = "Enter seller phone";
        if (!data.isTermAndConditionAccepted) errors.termsAndConditionSelection = "Please check terms and conditions";

        return errors;
    }

    const onMakePaymentClick = async () => {
        setLoading(true);
        var error = validateForm(data);
        if (Object.keys(error).length > 0) {
            setLoading(false);
            setValidationError(error);
            return;
        } else {
            setValidationError({});
        }
        await onSubmit(data);
        setLoading(false);
    }

    const onSaveAsDraftClikc = async () => {

        setDraftLoading(true);
        var error = validateForm(data);
        if (Object.keys(error).length > 0) {
            setDraftLoading(false);
            setValidationError(error);
            return;
        } else {
            setValidationError({});
        }
        await onSaveAsDraft(data);
        setDraftLoading(false);
    }

    return (
        <>
            {<Modal show={showModal} onHide={handleClose} centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Inspectiver Terms and Conditions for Inspection Orders</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="px-3">
                        <p><span><br /></span><span >Please read these Terms and Conditions carefully before placing an order with Inspectiver. By purchasing an inspection service, you agree to be bound by these Terms.</span></p>
                        <p><strong><span style={{ fontWeight: "bold" }}>1. Services Provided</span></strong></p>
                        <p><span>Inspectiver offers pre-purchase vehicle inspection services through independent inspectors. The inspection includes a visual and functional assessment based on the vehicle’s accessibility and the information provided by the seller.</span></p>
                        <p><strong><span style={{ fontWeight: "bold" }}>2. Scope of Inspection</span></strong></p>
                        <p>
                            <span>
                                <ul>
                                    <li>Inspections are non-invasive and based on visible and accessible areas of the vehicle.</li>
                                    <li>Inspectors do not dismantle any part of the vehicle.</li>
                                    <li>Road tests are only performed when the vehicle is legally operable and permitted by the seller.</li>
                                    <li>Inspections do not guarantee future vehicle performance or condition.</li>
                                </ul>
                            </span>
                        </p>
                        <p><strong><span style={{ fontWeight: "bold" }}>3. Limitations</span></strong></p>
                        <p>
                            <span>
                                <ul>
                                    <li>Inspectiver is not liable for hidden defects or issues that cannot be detected through visual inspection.</li>
                                    <li>The report reflects the vehicle’s condition only at the time of inspection.</li>
                                    <li>Inspectiver does not provide mechanical warranties or insurance.</li>
                                </ul>
                            </span>
                        </p>

                        <p><strong><span style={{ fontWeight: "bold" }}>4. Customer Responsibilities</span></strong></p>
                        <p>
                            <span>
                                <ul>
                                    <li>Provide accurate vehicle and seller information when placing an order.</li>
                                    <li>Ensure that the vehicle is available, accessible, and in a safe location for inspection.</li>
                                    <li>Customers may update inspection details (vehicle, seller, location, etc.) up to 24 hours prior to the scheduled appointment.</li>
                                </ul>
                            </span>
                        </p>
                        <p><strong><span style={{ fontWeight: "bold" }}>5. Payments and Refunds</span></strong></p>
                        <p>
                            <span>
                                <ul>
                                    <li>Full payment is required at the time of placing an order.</li>
                                    <li>Inspection orders are non-refundable, except in the case where Inspectiver is unable to conduct the inspection within 8 business days of the order being placed. In such cases, a full refund will be issued automatically.</li>
                                    <li>No refunds will be issued due to seller cancellation, no-show, or incorrect information provided by the customer.</li>
                                    <li>No refunds are issued once the inspection has been completed.</li>
                                </ul>
                            </span>
                        </p>
                        <p><strong><span style={{ fontWeight: "bold" }}>6. Report Delivery</span></strong></p>
                        <p>
                            <span>
                                <ul>
                                    <li>Inspection reports are typically delivered within 24 hours of the inspection via email or the Inspectiver platform.</li>
                                    <li>Customers are responsible for reviewing the report and making their purchase decision based on the information provided.</li>
                                </ul>
                            </span>
                        </p>

                        <p><strong><span style={{ fontWeight: "bold" }}>7. Liability Disclaimer</span></strong></p>
                        <p><span>Inspectiver and its inspectors are not responsible for:</span></p>
                        <p>
                            <span>
                                <ul>
                                    <li>Inaccuracies due to misinformation provided by the seller or customer.</li>
                                    <li>Future vehicle issues or repairs.</li>
                                    <li>Any decisions made based on the inspection report.</li>
                                </ul>
                            </span>
                        </p>

                        <p><strong><span style={{ fontWeight: "bold" }}>8. Use of Reports</span></strong></p>
                        <p>
                            <span>
                                <ul>
                                    <li>The inspection report is intended for the individual customer who ordered the service.</li>
                                    <li>Sharing, publishing, or distributing reports without written consent from Inspectiver is strictly prohibited.</li>
                                </ul>
                            </span>
                        </p>

                        <p><strong><span style={{ fontWeight: "bold" }}>9. Changes to Terms</span></strong></p>
                        <p><span>Inspectiver reserves the right to update these Terms at any time. Continued use of the service after changes implies acceptance of the new terms.</span></p>

                        <p><strong><span style={{ fontWeight: "bold" }}>10. Contact</span></strong></p>
                        <p><span>For questions or support, contact us at:</span></p>
                        <p><span>support@inspectiver.com</span></p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-dark" onClick={handleClose}>Close</button>
                </Modal.Footer>
            </Modal>}
            <Row>
                <div className="checkout-form border p-4 rounded">
                    <div className="row">
                        <div className="col-md-4">
                            <div style={{ cursor: 'pointer' }}
                                className={`m-2 border p-2 rounded ${data.vehicleType == "1" ? "bg-primary text-white" : ""}`}
                                onClick={() => updateFields({ vehicleType: "1" })}>
                                <div className="form-check ">
                                    <label
                                        htmlFor="car"
                                        className="d-flex flex-row align-items-center"
                                    >
                                        <img src={car} width={40} className="mx-3" />
                                        <div className="row">
                                            <div className="col-md-8">
                                                <span className="align-items-center">CAR / SUV</span>
                                            </div>
                                            <div className="col-md-4">
                                                <span className="align-items-center badge bg-primary">$ {prices?.carAmount?.toFixed(2)}</span>
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* <div className="col-md-3">
                        <div style={{ cursor: 'pointer' }}
                            className={`m-2 border p-2 rounded ${data.vehicleType == "2" ? "bg-primary text-white" : ""}`}
                            onClick={() => updateFields({ vehicleType: "2" })}>
                            <div className="form-check">
                                <label
                                    htmlFor="motorcycle"
                                    className="d-flex flex-row align-items-center"
                                >
                                    <img src={motorbike} width={40} className="mx-3" />
                                    MOTORCYCLE
                                </label>
                            </div>
                        </div>
                    </div> */}

                        <div className="col-md-4">
                            <div style={{ cursor: 'pointer' }}
                                className={`m-2 border p-2 rounded ${data.vehicleType == "3" ? "bg-primary text-white" : ""}`}
                                onClick={() => updateFields({ vehicleType: "3" })}>
                                <div className="form-check">
                                    <label
                                        htmlFor="truck"
                                        className="d-flex flex-row align-items-center"
                                    >
                                        <img src={truck} width={40} className="mx-3" />
                                        <div className="row">
                                            <div className="col-md-8">
                                                <span> TRUCK / VAN</span>

                                            </div>
                                            <div className="col-md-4">
                                                <span className="align-items-center badge bg-primary">$ {prices?.commercialAmount?.toFixed(2)}</span>
                                            </div>

                                        </div>

                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* <div className="col-md-3">
                        <div style={{ cursor: 'pointer' }}
                            className={`m-2 border p-2 rounded ${data.vehicleType == "4" ? "bg-primary text-white" : ""}`}
                            onClick={() => updateFields({ vehicleType: "4" })}>
                            <div className="form-check">
                                <label
                                    htmlFor="rv"
                                    className="d-flex flex-row align-items-center"
                                >
                                    <img src={van} width={40} className="mx-3" />
                                    RV
                                </label>
                            </div>
                        </div>
                    </div> */}
                    </div>

                    <Row form>
                        <Col md={6}>
                            <FormGroup>
                                <AutoCompleteInput placeholder={disableMake ? "Make (Loading, please wait)" : "Make*"} disabled={disableMake} value={makeInput} options={makes} onSuggestionClick={onMakeClick} handleChange={onMakeChange} />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <AutoCompleteInput placeholder="Model*" disabled={disableModel} value={modelInput} options={models} onSuggestionClick={onModelClick} handleChange={onModelChange} />
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Input
                                    type="select"
                                    id="year"
                                    name="year"
                                    value={data.year}
                                    placeholder="Year*"
                                    className="form-control"
                                    onChange={e => updateFields({ year: e.target.value })}
                                >
                                    <option value="">Year</option>
                                    {YearsArray.map(t => <option value={t}>{t}</option>)}
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Input
                                    id="licensePlate"
                                    type="text"
                                    name="licensePlate"
                                    className="form-control"
                                    placeholder="License Plate (optional)"
                                    value={data.licensePlate}
                                    onChange={e => updateFields({ licensePlate: e.target.value })}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Input
                                    id="VIN"
                                    type="text"
                                    name="VIN"
                                    className="form-control"
                                    placeholder="VIN (optional)"
                                    value={data.VIN}
                                    onChange={e => updateFields({ VIN: e.target.value })}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row form>
                        <Col md={12}>
                            <FormGroup>
                                <Input
                                    id="sellerContactName"
                                    type="text"
                                    name="sellerContactName"
                                    className="form-control"
                                    placeholder="Contact Name *"
                                    value={data.sellerContactName}
                                    onChange={e => updateFields({ sellerContactName: e.target.value })}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={12}>
                            <FormGroup>
                                <LocationAutocomplete onPlaceChanged={onSellerPlaceChanged} placeholder="Seller Address" defaultValue={data.sellerAddress} />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>

                                <Input
                                    type="test"
                                    id="sellerCity"
                                    name="sellerCity"
                                    placeholder="City *"
                                    value={data.sellerCity}
                                    className="form-control custom-form-control"
                                    disabled
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Input
                                    type="select"
                                    id="sellerState"
                                    name="sellerState"
                                    placeholder="State *"
                                    value={data.sellerState}
                                    className="form-control custom-form-control"
                                    disabled
                                >
                                    <Options data={States} />
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Input
                                    id="sellerZipCode"
                                    type="text"
                                    name="sellerZipCode"
                                    className="form-control custom-form-control"
                                    placeholder="Zip Code *"
                                    disabled
                                    value={data.sellerZipCode}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <PhoneMaskInput
                                    name="sellerPhone"
                                    placeholder="Phone"
                                    className="form-control"
                                    value={data.sellerPhone}
                                    onChange={e => updateFields({ sellerPhone: e.target.value })}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row form>
                        <Col md={12}>
                            <FormGroup>
                                <Input
                                    id="requesterNote"
                                    type="textarea"
                                    name="requesterNote"
                                    className="form-control"
                                    placeholder="Please enter if you have any note to inspector (optional)"
                                    value={data.requesterNote}
                                    onChange={e => updateFields({ requesterNote: e.target.value })}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={12}>
                            <FormGroup>
                                <div className="form-group">
                                    <div className="form-check">
                                        <input type="checkbox" className="form-check-input" id="termsAndContidition" checked={data.isTermAndConditionAccepted} onChange={checkHandler} />
                                        <label className="form-check-label" htmlFor="termsAndContidition" >I accept </label> <label><a style={{ cursor: "pointer", textDecorationLine: "underline" }} onClick={() => openTermsAndConditionModal()} >Terms and Conditions </a></label>
                                    </div>
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div style={{ color: "red", fontSize: "0.9rem" }}>
                                {Object.keys(validationError).length > 0 ? Object.values(validationError).map((item, index) => <div key={index} className="row"><span>* {item}</span></div>) : null}
                            </div>
                        </Col>
                        <Col md={8}>
                        </Col>
                        <Col md={2} className="mt-2 mt-md-0">
                            {!orderId && <SpinnerButton type="button" className="btn btn-secondary btn-sm w-100 w-md-auto" onClick={onSaveAsDraftClikc} loading={draftLoading} text="Save as Draft" />}
                        </Col>
                        <Col md={2} className="mt-2 mt-md-0">
                            <SpinnerButton type="button" className="btn btn-primary btn-sm w-100 w-md-auto" onClick={onMakePaymentClick} disabled={loading} loading={loading} text="Make Payment" />
                        </Col>
                    </Row>
                </div>
            </Row>

        </>

    );

}

export default OrderForm;